import { Dispatch, SetStateAction } from 'react';
import { UseFormReturn } from 'react-hook-form';

import { Enum } from '~/data/enums';
import { DynamicTableCellConfig } from '~/legacy-components/LegacyDynamicFormTable/types';

import { IFormInput } from '../useDocuments';

export const getCellConfig = (
  docEnumType: Enum[],
  setEditedRows: Dispatch<SetStateAction<number[]>>,
  useFormMethods: UseFormReturn<IFormInput>,
) => {
  const {
    setValue,
    formState: { errors },
  } = useFormMethods;

  const addIndexEditedRows = (index: number) =>
    setEditedRows((prevState) => {
      if (prevState.includes(index)) {
        return prevState;
      }
      return [...prevState, index];
    });

  const onChangeFunction = {
    onChange: (
      index: number,
      onChange?: Function,
      value?: string | File | null,
    ) => {
      if (onChange) {
        onChange(value);
      }
    },
  };

  const columnConfigs = {
    fDocumentDocType: {
      type: 'select',
      clearable: false,
      width: '164px',
      disabled: false,
      options: docEnumType.map((eEnum) => ({
        value: eEnum.code,
        label: eEnum.name,
      })),
      ...onChangeFunction,
      error: (index: number) =>
        errors.document &&
        errors.document[index] &&
        errors.document[index]!.fDocumentDocType
          ? true
          : false,
      controllerConfig: {
        rules: { required: true },
      },
    },
    fDocumentCreated: {
      type: 'date',
      width: '120px',
      disabled: true,
      ...onChangeFunction,
    },
    fDocumentModified: {
      type: 'date',
      width: '120px',
      disabled: true,
      ...onChangeFunction,
    },
    fDocumentName: {
      type: 'attachment',
      width: '250px',
      onChange: (
        index: number,
        onChange?: Function,
        value?: string | File | null,
      ) => {
        if (onChange) {
          onChange(value ? (value as File).name : '');
          setValue(
            `document.${index}.fDocumentAttachment`,
            value as File | undefined,
          );
          setValue(`document.${index}.fDocumentId`, -1);
        }
      },
      error: (index: number) =>
        errors.document &&
        errors.document[index] &&
        errors.document[index]!.fDocumentName
          ? true
          : false,
      controllerConfig: {
        rules: { required: true },
      },
    },
    fDocumentDescription: {
      type: 'input',
      width: '250px',
      ...onChangeFunction,
    },
    fDocumentExpirationDate: {
      type: 'date',
      width: '120px',
      ...onChangeFunction,
    },
    fDocumentApprovalStatus: {
      type: 'text',
      width: '90px',
      ...onChangeFunction,
    },
  };

  const getCellConfig = (
    cellName: string,
    index: number,
    fDocumentId?: number,
    value?: string | number,
  ) => {
    const fieldName = `document.${index}.${cellName}`;

    const columnConfigForCell: DynamicTableCellConfig =
      columnConfigs[cellName as keyof typeof columnConfigs];

    const customConfigs = {
      onChange: (index: number, onChange: Function, value: string & File) => {
        columnConfigForCell.onChange(index, onChange, value);
        if (fDocumentId) {
          addIndexEditedRows(fDocumentId);
        }
      },
    };

    return {
      name: fieldName,
      ...columnConfigForCell,
      ...customConfigs,
    } as DynamicTableCellConfig;
  };

  return getCellConfig;
};
